import { v1 } from '@/api/client';

const prefix = 'data:text/csv;charset=utf-8,';

export const createCsv = (data: any[][]) => {
  return data.map((e) => e.join(',')).join('\n');
};

export const downloadCsvFile = (fileName: string, file: string) => {
  const encodedUri = encodeURIComponent(file);

  const link = document.createElement('a');
  link.setAttribute('href', prefix + encodedUri);
  link.setAttribute('download', `${fileName || 'file'}.csv`);
  document.body.appendChild(link); // Required for FF

  link.click(); // This will download the data file named "my_data.csv".
  //window.open(encodedUri);
};

export const downloadFile = (blobUrl: string, fileName: string) => {
  const link = document.createElement('a');
  link.setAttribute('href', blobUrl);
  link.setAttribute('download', fileName);

  link.click();
};

export const getFileName = (title?: string, fileExtension?: string) => {
  const name = (title ?? '').trim();
  const extension = (fileExtension ?? '').trim();

  return (
    (name.length > 0 ? name : 'file') +
    (extension.length > 0 ? '.' + extension : '')
  );
};

export const readFileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => {
      resolve(btoa(event.target?.result as string));
    };
    reader.onerror = (event) => {
      reject(event);
    };
  });

export const fetchFileAsBlobUrl = (url: string, mimeType: string) =>
  v1
    .get<Blob>(url, {
      requestInit: { headers: { Accept: mimeType + ',*/*' } },
      responseType: 'blob',
    })
    .then((resObj) => {
      const newBlob = new Blob([resObj], { type: mimeType });
      return window.URL.createObjectURL(newBlob);
    });
